import React from "react";
import {
  MedicalDomainTask1,
  MedicalDomainTask11,
  MedicalDomainTask2,
  MedicalDomainTask3,
  MedicalDomainTask4, 
  MedicalDomainTask5, 
  MedicalDomainTask6, 
  MedicalDomainTask7, 
  MedicalDomainTask8, 
  MedicalDomainTask9,
  MedicalDomainTaskPlaceholder
} from "./MedicalDomainTasks";

interface MedicalDomainTaskFactoryProps {
  slideKey: string;
  topContentRef: React.RefObject<HTMLDivElement>;
  setHeader: (header: string) => void;
  questionCompleter: any
}

const MedicalDomainTaskFactory: React.FC<MedicalDomainTaskFactoryProps> = (
  props
) => {
  const { slideKey, setHeader, questionCompleter, topContentRef } = props;

  const getCurrentSlide = () => {
    switch (slideKey) {
      case "MedicalDomainTask1":
        return MedicalDomainTask1;
      case "MedicalDomainTask2":
        return MedicalDomainTask2;
      case "MedicalDomainTask3":
        return MedicalDomainTask3;
      case "MedicalDomainTask4":
        return MedicalDomainTask4;
      case "MedicalDomainTask5":
        return MedicalDomainTask5;
      case "MedicalDomainTask6":
        return MedicalDomainTask6;
      case "MedicalDomainTask7":
        return MedicalDomainTask7;
      case "MedicalDomainTask8":
        return MedicalDomainTask8;
      case "MedicalDomainTask9":
        return MedicalDomainTask9;
      case "MedicalDomainTask11":
        return MedicalDomainTask11;
      default:
        return MedicalDomainTaskPlaceholder;
    }
  };

  const currentSlide = getCurrentSlide()!(questionCompleter, topContentRef);

  setHeader(currentSlide.header);

  return <>{currentSlide.content}</>;
};

export default MedicalDomainTaskFactory;
